import { LMoperationHours,  ApiLMoperationHours } from "./types";

export const parseAPILMoperationHours = (apiLMoperationHours: ApiLMoperationHours): LMoperationHours => {
  return {    
    operationHoursType: apiLMoperationHours.operationHoursType,
    operationHours: apiLMoperationHours.operationHours
  }
}
